/**
 * @file 提交问卷
 * @author liudy
 * @see http://api.umucdn.cn/project/106/wiki
 */

import Api from '../../path';
import { PollType } from '@umu/umu-types';
import { fetchData } from '@umu/umu-fetch';

export interface ISubmitPollInput {
    parent_id: number; // int 作业问卷ID
    parent_type: PollType; // int 1、保存作业多维度评价问卷模板 2、保存作业多维度评价问卷
    obj_id: number; // int 评价对象ID，比如学生提交作业的homework_id
    submit_data: string; // json 学员填写问卷信息
}

export interface ISubmitPollOutput {
    status: number;
}

export const submitPoll = (data: ISubmitPollInput): Promise<IResponse<ISubmitPollOutput>> => {
    return fetchData(Api.POLL_SUBMIT, data);
};
